import React from "react";
import { Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Sticky from "react-stickynode";
import {
  changeSingleContactListModal,
  setEditContactDisplay,
} from "../../../../redux/actions/single-contact-list";
import EmptyView from "./empty-container";
import ContactView from "./details-container";
import LoadPreview from "./loading-container";
import { FadeButton } from "../../../library/button";
import { UpperRow } from "../../../library/upper-row";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const loadRecords = useSelector(
    (state) => state.singleContactList.fetchRecords.loading
  );
  const loadActive = useSelector(
    (state) => state.singleContactList.viewSingleRecord.loading
  );
  const activeDisplay = useSelector(
    (state) => state.singleContactList.activeDisplay
  );

  const renderRightDisplay = () => {
    if (!loadRecords && !loadActive) {
      if (Object.keys(activeDisplay).length > 0) {
        return <ContactView />;
      } else {
        return <EmptyView />;
      }
    } else {
      return <LoadPreview />;
    }
  };

  const clickEditContact = () => {
    dispatch(changeSingleContactListModal({ editSingleModal: true }));
    dispatch(setEditContactDisplay(activeDisplay));
  };

  const renderMainButtons = () => {
    return [
      <FadeButton
        onClick={() => clickEditContact()}
        icon={<i class="fad fa-pen"></i>}
        color="blue"
        title="Endre"
      />,
    ];
  };

  const renderUpperRow = () => {
    if (!loadRecords && Object.keys(activeDisplay).length > 0) {
      return <UpperRow title="" buttons={renderMainButtons()} />;
    }
    return null;
  };

  return (
    <Col className="dashboard-single-contact-list-right-container parentscroll">
      <Sticky enabled={true} top={100}>
        <Col className="inner-dashboard-single-contact-list-right-container">
          {renderUpperRow()}
          {renderRightDisplay()}
        </Col>
      </Sticky>
    </Col>
  );
};

export default Index;
